module.exports = __webpack_public_path__ + "img/liebian.6ad47044.png";